<div *ngIf="showLoader" class="loading-model property">
  <p-progress-spinner></p-progress-spinner>
</div>

<p-button
  type="button"
  label="Add Export"
  icon="pi pi-plus"
  (onClick)="addexports()"
  class="new-btn"
  *ngIf="exports.length < 10 && !disableField"
/>
<p-accordion [value]="selected" (valueChange)="selected = $event" [multiple]="true" *ngIf="exports.length > 0">
  @for (exp of exports | uiFilter: searchTerm : ['name']; track $index; let i = $index) {
    <p-accordion-panel value="0" class="border-class" [ngClass]="{ 'bor-err': imp.err }">
      <p-accordion-header>
        <div class="header-delete-icon-wrapper">
          <div class="imp-header-wrapper">
            <div class="imp-header">{{ exp.name }}</div>
          </div>
          <div class="del-icon-wrapper" [ngClass]="{ disableField: disableField }">
            <button
              (click)="delExp(i)"
              *ngIf="exp.name"
              type="button"
              class="delete-icon"
              aria-hidden="true"
              showDelay="100"
              hideDelay="100"
              [disabled]="disableField"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Delete"
              tooltipPosition="top"
            >
              <svg-icon src="assets\images\svg\trash.svg"></svg-icon>
            </button>
          </div>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="expname-{{ i }}"
            >Export Template Name
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Enter the Export Template Name. You can create multiple Export templates."
            ></i>
          </label>
          <div class="col-sm-6 input-ctrl pl-0">
            <input
              [name]="exp.name"
              id="expname-{{ i }}"
              type="text"
              [(ngModel)]="exp.name"
              [ngClass]="{ 'bor-err': exp.err }"
              maxlength="64"
              (focusout)="onNameChange($event, exp)"
              class="form-control form-control-sm"
            />
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="fields-for-export-template"
            >Fields for Export Template
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Select fields for the template and define their order using the picklist."
            ></i>
          </label>

          <div class="col-sm-6 input-ctrl pl-0 d-flex" id="fields-for-export-template">
            <div class="p-inputgroup pl-2">
              <div class="fields" *ngIf="exp?.fields.length">
                <span *ngFor="let field of exp.fields" class="field-name mr-1">
                  {{ field.altName ? field.altName : fieldIdMap[field.sid] }}
                </span>
              </div>
              <span class="p-inputgroup-addon">
                <button
                  type="button"
                  class="p-element p-component p-button-icon-only"
                  title="Reorder"
                  (click)="togglePickList($event, exp)"
                >
                  <i class="pi pi-pencil"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" [for]="exp.notifyMail"
            >Notify Email
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="An email notification will be sent once export is completed"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0">
            <p-checkbox
              [binary]="true"
              [disabled]="disableField"
              [inputId]="exp.notifyMail"
              [name]="exp.notifyMail"
              [attr.id]="exp.notifyMail"
              styleClass="mt-2"
              [(ngModel)]="exp.notifyMail"
              (onChange)="onNotifyMailChange($event, exp)"
            ></p-checkbox>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems" *ngIf="exp.notifyMail">
          <label class="col-sm-6 col-form-label" for="mail-template"
            >Mail Template
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Define the mail structure for the notification mail to be sent"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0">
            <vb-mail-template
              id="mail-template"
              [element]="exp"
              [(ngModel)]="exp.mailTemplate"
              [disableField]="disableField"
              [dataFrom]="'export'"
              (opValue)="onMailChanges($event, exp)"
              [formDetails]="formData"
            >
            </vb-mail-template>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="multiselect-filter"
            >Filters
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Select the fields to be used as filters during export"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0">
            <div class="p-inputgroup custom-multiselect">
              <p-multiselect
                id="multiselect-filter"
                resetFilterOnHide="true"
                placeholder="Select"
                [options]="searchableFieldOps"
                [(ngModel)]="exp.filters"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                display="chip"
                (onClick)="onSearhableFldChangesOnRemove($event, exp)"
                class="multiselect-style"
                (onPanelHide)="onSearhableFldChanges(exp)"
              >
              </p-multiselect>
            </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems radio-wrapper">
          <label class="col-sm-6 col-form-label" for="output-file-type"
            >Output File Types
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="Defines the output file types to be used for export"
            ></i
          ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0" id="output-file-type">
            <div class="field-radiobutton" *ngFor="let option of srcFileTypes">
              <p-radiobutton
                [(ngModel)]="exp.fileTypes[0]"
                [value]="option.value"
                [inputId]="option.value"
                (onClick)="setValueOnChanges($event, exp)"
                [disabled]="disableField"
              ></p-radiobutton>
              <label class="mb-0 ml-1 mr-2" [for]="option.value">{{ option.name }}</label>
            </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems radio-wrapper">
          <label class="col-sm-6 col-form-label" for="who-can-export"
            >Who can export
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="The field specifies the roles who can export."
            ></i
          ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0" id="who-can-export">
            <vb-role-lookup
              [element]="element"
              [(ngModel)]="exp.roles"
              [importProp]="true"
              [disabled]="disableField"
              (change)="setValueOnChanges($event, exp)"
            ></vb-role-lookup>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  }
</p-accordion>
<p-dialog
  header="{{ 'EXP_TEMP' | translate }}"
  [modal]="true"
  [(visible)]="showPickList"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw' }"
  appendTo="body"
>
  <p-picklist
    [source]="source"
    [target]="target"
    [responsive]="true"
    sourceHeader="Available Fields"
    targetHeader="Selected Fields"
    filterBy="searchValue"
    sourceFilterPlaceholder="Search by name"
    (onTargetSelect)="ontargetSelect($event)"
    targetFilterPlaceholder="Search by name"
    (onMoveToTarget)="onMoveToTarget($event)"
    (onMoveAllToTarget)="onMoveToTarget($event)"
    (onMoveToSource)="onMoveToSource($event)"
    (onMoveAllToSource)="onMoveToSource($event)"
    [disabled]="disableField"
    *ngIf="showPickList"
  >
    <ng-template let-property #item>
      <div class="property-detail">
        <div class="d-flex align-items-center justify-content-between">
          <div class="header">
            <input
              (keydown)="stopPropagation($event)"
              class="alt-txt"
              type="text"
              alphaNumWithSpace
              *ngIf="property.edit"
              [(ngModel)]="property.name"
            />
            <span *ngIf="property.edit" class="ml-1">
              <span
                class="ml-1 pick-icons p-button-icon pi pi-check"
                (click)="saveFieldName(property)"
                aria-hidden="true"
              ></span>
              <span
                class="ml-1 pick-icons p-button-icon pi pi-times"
                (click)="cancelEdit(property)"
                aria-hidden="true"
              ></span>
            </span>
            <div *ngIf="property.name !== fieldIdMap[property.sid] && !property.edit" class="alt-name">
              {{ property.name }}
            </div>
            <div [ngClass]="{ 'sub-text mt-1': property.name !== fieldIdMap[property.sid] }">
              <span class="subFld-nme mr-1" *ngIf="property.subField">{{ property.subField }} </span
              >{{ fieldIdMap[property.sid] }}
            </div>
          </div>
          <span
            class="ml-2 pick-icons p-button-icon pi pi-pencil"
            *ngIf="property.allowEdit && !property.edit"
            (click)="editFieldName(property)"
            aria-hidden="true"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="Provide the alternate name for the field used for Export Template"
            tooltipPosition="top"
          ></span>
        </div>
      </div>
    </ng-template>
    <ng-template #emptymessagesource>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
    <ng-template #emptymessagetarget>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
  </p-picklist>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog($event)">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="savePicklist()" [disabled]="disableField">
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>
<div class="properties-group-name"></div>
